import React from 'react';

const ProcessSection: React.FC = () => {
  const steps = [
    {
      number: '01',
      title: 'Initial Consultation',
      description: 'Meet with our certified business broker to discuss your goals, budget, and industry preferences.',
      icon: 'ri-user-heart-line'
    },
    {
      number: '02',
      title: 'Financial Assessment',
      description: 'Comprehensive evaluation of your financial capacity and business purchase feasibility.',
      icon: 'ri-line-chart-line'
    },
    {
      number: '03',
      title: 'Business Search',
      description: 'Customized searches presenting qualified business opportunities in your area.',
      icon: 'ri-search-2-line'
    },
    {
      number: '04',
      title: 'SBA Loan Support',
      description: 'Complete assistance with SBA financing, forms, and lender applications.',
      icon: 'ri-bank-card-line'
    },
    {
      number: '05',
      title: 'Pre-Approval',
      description: 'Assistance in securing SBA pre-approval letter to strengthen your negotiating position.',
      icon: 'ri-shield-check-line'
    },
    {
      number: '06',
      title: 'Acquisition Success',
      description: 'Complete your business purchase with confidence and expert guidance.',
      icon: 'ri-trophy-line'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Your Path to Business Ownership
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our proven 6-step process ensures you have the guidance and support needed for successful business acquisition.
          </p>
        </div>

        <div className="relative">
          {/* Desktop Timeline */}
          <div className="hidden lg:block">
            <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-teal-200"></div>
            
            {steps.map((step, index) => (
              <div key={index} className={`flex items-center mb-16 ${index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`}>
                <div className={`w-1/2 ${index % 2 === 0 ? 'pr-12 text-right' : 'pl-12 text-left'}`}>
                  <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                    <div className={`flex items-center mb-4 ${index % 2 === 0 ? 'justify-end' : 'justify-start'}`}>
                      <div className="w-12 h-12 bg-teal-500 rounded-full flex items-center justify-center mr-4">
                        <i className={`${step.icon} text-white text-xl`}></i>
                      </div>
                      <h3 className="text-xl font-bold text-gray-900">{step.title}</h3>
                    </div>
                    <p className="text-gray-600">{step.description}</p>
                  </div>
                </div>
                
                <div className="absolute left-1/2 transform -translate-x-1/2 w-16 h-16 bg-teal-500 rounded-full flex items-center justify-center shadow-lg">
                  <span className="text-white font-bold text-lg">{step.number}</span>
                </div>
                
                <div className="w-1/2"></div>
              </div>
            ))}
          </div>

          {/* Mobile Timeline */}
          <div className="lg:hidden">
            <div className="absolute left-8 top-0 bottom-0 w-1 bg-teal-200"></div>
            
            {steps.map((step, index) => (
              <div key={index} className="relative flex items-start mb-12">
                <div className="absolute left-8 transform -translate-x-1/2 w-12 h-12 bg-teal-500 rounded-full flex items-center justify-center shadow-lg">
                  <span className="text-white font-bold text-sm">{step.number}</span>
                </div>
                
                <div className="ml-20">
                  <div className="bg-white p-6 rounded-2xl shadow-lg border border-gray-100">
                    <div className="flex items-center mb-3">
                      <div className="w-10 h-10 bg-teal-500 rounded-full flex items-center justify-center mr-3">
                        <i className={`${step.icon} text-white text-lg`}></i>
                      </div>
                      <h3 className="text-lg font-bold text-gray-900">{step.title}</h3>
                    </div>
                    <p className="text-gray-600 text-sm">{step.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
